import { ServiceData } from '../../service';
import db from '../../index';
import { entityServiceFactory } from '../../entityServiceFactory';

export interface InstallationBasisServiceData extends ServiceData {}
const { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain } =
  entityServiceFactory<InstallationBasisServiceData>(db, 'installationBasisService');

export { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain };
